import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/app/curriculum/create')({
  component: lazyRouteComponent(() => import('./-create')),
});
